import { client } from "api";
import { Company } from "models/Company";

export type MarkCheckedRequest = {
  id: Company["id"];
}

export type MarkCheckedResponse = Company;

export const markChecked = ({ id }: MarkCheckedRequest) =>
  client.post<MarkCheckedResponse>(`/company/${id}/mark-checked`).then((res) => res.data);
